import { retrieveCacheBookingAction } from "../../../Actions/LogicActions/Booking/RetrieveCacheBookingAction";
import { loadMoreBookingsAction } from "../../../Actions/LogicActions/Booking/LoadMoreBookingsAction";
import { upcomingPastBookingMonthFilterAction } from "../../../Actions/LogicActions/Booking/UpcomingPastBookingMonthFilterAction";
import { upcomingPastBookingTabAction } from "../../../Actions/LogicActions/Booking/UpcomingPastBookingTabAction";
import { addToCalendarAction } from "../../../Actions/UIActions/Booking/AddToCalendarAction";
import { serviceRequestClaimClickAction } from "../../../Actions/UIActions/Booking/ServiceRequestClaimClickAction";
import { upcomingPastBookingDetailsAction } from "../../../Actions/UIActions/Booking/UpcomingPastBookingDetailsAction";
import { cancelBookingRedirectClickAction } from "../../../Actions/UIActions/CancelBooking/CancelBookingRedirectClickAction";
import { changeDateRedirectClickAction } from "../../../Actions/UIActions/ChangeDate/ChangeDateRedirectClickAction";
import { retrieveBookingShowModalAction } from "../../../Actions/UIActions/RetrieveBooking/RetrieveBookingShowModalAction";
import { ticketPopupOpenCloseAction } from "../../../Actions/UIActions/TicketDetail/TicketPopupOpenCloseAction";
import { requestInvoicePopupOpenCloseAction } from "../../../Actions/UIActions/TicketDetail/RequestInvoicePopupOpenCloseAction";
import { requestInvoiceSubmitAction } from "../../../Actions/LogicActions/RequestInvoice/RequestInvoiceSubmitAction";
import { upgradeToPremiumAction } from '../../../Actions/LogicActions/UpgradePremium/UpgradeToPremiumAction';
import { processUpgradeOffersAction } from '../../../Actions/LogicActions/UpgradePremium/ProcessUpgradeOffersAction';
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { bookingTree } from "../../../Orchestrator/ConstantTree";
import { cancelBookingTree } from "../../../Orchestrator/ConstantTree/CancelBookingPage/CancelBookingTree";
import { changeDateTree } from "../../../Orchestrator/ConstantTree/ChangeDatePage/ChangeDateTree";
import { upgradeBookingTree } from "../../../Orchestrator/ConstantTree/UpgradeBooking/UpgradeBookingTree";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IAddToCalendarActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/AddToCalendarActionParams";
import { IAddShuttleTransferActionParams, IBookingDetailsActionParams, IMonthFilterActionParams, ITabChangeActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/UpcomingPastBookingActionParams";
import { ITicketModalPopupAction } from "../../../Orchestrator/Types/Interface/EventParams/TicketAction";
import { ChangeDateContext } from "../../ChangeDate/Context/ChangeDateContext";
import { TicketDetailContext } from "../../TicketDetail/Context/TicketDetailContext";
import { UpcomingPastBookingContext } from "../Context/UpcomingPastBookingContext";
import { passengerTypeAction, stopAction } from "../../../Actions/Index";
import { addShuttleTransferClickAction } from "../../../Actions/UIActions/AddShuttleTransfer/AddShuttleTransferClickAction";

class UpcomingPastBookingStep extends StepFlow {
    get stepName() { return "UpcomingPastBooking_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<ITabChangeActionParams, void>({
                eventName: bookingTree.UpcomingPast.TabDefaultChange,
                handler: async (payload) => {
                    upcomingPastBookingTabAction.setParams(payload.data!)
                    await upcomingPastBookingTabAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IMonthFilterActionParams, void>({
                eventName: bookingTree.UpcomingPast.MonthFilter.Click,
                handler: async (payload) => {
                    upcomingPastBookingMonthFilterAction.setParams(payload.data!)
                    await upcomingPastBookingMonthFilterAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: bookingTree.UpcomingPast.LoadMore.Click,
                handler: async () => {
                    await loadMoreBookingsAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IBookingDetailsActionParams, void>({
                eventName: bookingTree.UpcomingPast.Details.Click,
                handler: async (payload) => {
                    let context = this.getCtx<UpcomingPastBookingContext>("upcomingPastBookingContext")!;
                    upcomingPastBookingDetailsAction.setParams(payload.data!)
                    await upcomingPastBookingDetailsAction.execute();

                    if (upcomingPastBookingDetailsAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        context.bookingId = upcomingPastBookingDetailsAction.result!

                        _eventBus.emit({
                            eventName: "FLOW_CLOSE",
                            data: "AfterSalesBookingFlow",
                        });

                        // "Add shuttle transfer" on a card takes this same path —
                        // it only differs by the query param the details page
                        // reads to raise a shuttle-add request.
                        const detailsParams: string[] = [];
                        const directionParam = payload.data?.direction == TripTypeEnum.IN_BOUND
                            ? "inbound"
                            : payload.data?.direction == TripTypeEnum.OUT_BOUND
                                ? "outbound"
                                : "";
                        if (directionParam) detailsParams.push(`direction=${directionParam}`);
                        if ((payload.data as { addShuttle?: boolean })?.addShuttle) detailsParams.push("addShuttle=1");
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: `/bookings/details/${upcomingPastBookingDetailsAction.result}${detailsParams.length ? `?${detailsParams.join("&")}` : ""}`,
                        });

                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<ITicketModalPopupAction, void>({
                eventName: bookingTree.Ticket.Popup.OpenClose,
                handler: async (payload) => {
                    let context = this.getCtx<TicketDetailContext>("ticketDetailContext")!;
                    context.bookingId = payload.data?.bookingId!
                    ticketPopupOpenCloseAction.setParams(payload.data!);
                    await ticketPopupOpenCloseAction.execute();
                    if (ticketPopupOpenCloseAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        const context = this.getCtx<UpcomingPastBookingContext>("upcomingPastBookingContext")!
                        if (context) {
                            context.nextTo = "TicketDetailFlow"
                            this.next();
                        }
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IAddToCalendarActionParams, void>({
                eventName: bookingTree.AddToCalendar.Click,
                handler: async (payload) => {
                    addToCalendarAction.setParams(payload.data!);
                    await addToCalendarAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: cancelBookingTree.CancelBooking.CancelBookingRedirectClick,
                handler: async (data: any) => {
                    cancelBookingRedirectClickAction.setParams(data.data!);
                    await cancelBookingRedirectClickAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: changeDateTree.ChangeDate.ChangeDateRedirectClick,
                handler: async (data: any) => {
                    let context = this.getCtx<ChangeDateContext>("changeDateContext")!;
                    changeDateRedirectClickAction.setParams(data.data!);
                    await changeDateRedirectClickAction.execute();
                    if (changeDateRedirectClickAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        context.allFulFillOutBoundPassIds = changeDateRedirectClickAction.result?.allFulFillOutBoundPassIds ?? [];
                        context.outBoundPassengerPriceList = changeDateRedirectClickAction.result?.outBoundPassengerPriceList ?? [];
                        context.bookingResponse = changeDateRedirectClickAction.result?.bookingResponse ?? null;
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: data.data.route,
                        })
                    }
                }
            })
        )

        /**
         * This event close the upcoming flow
         * And start retrieve booking flow.
         * if retrieve booking start by clicking Retrieve Booking button
         * Also this event manage retrieve booking modal popup open and close status
        */
        this.registerEventSubscription(
            _eventBus.on<boolean, void>({
                eventName: bookingTree.RetrieveBooking.Button.Click,
                handler: async ({ data }) => {
                    const context = this.getCtx<UpcomingPastBookingContext>("upcomingPastBookingContext")!
                    if (context && data != undefined) {
                        retrieveBookingShowModalAction.setParams(data)
                        await retrieveBookingShowModalAction.execute()
                        if (isActionRunSuccessfully(retrieveBookingShowModalAction)) {
                            context.nextTo = "RetrieveBooking";
                            this.next()
                        }
                    }
                }
            })
        )
        /**
         * This event close the upcoming flow
         * And start retrieve booking flow.
         * if retrieve booking start from upcoming section
        */
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: bookingTree.RetrieveBooking.StartFrom.Upcoming,
                handler: async ({ data }) => {
                    const context = this.getCtx<UpcomingPastBookingContext>("upcomingPastBookingContext")!
                    if (context) {
                        context.nextTo = "RetrieveBooking";
                        this.next()
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: bookingTree.RetrieveBooking.Check.CashData,
                handler: async ({ data }) => {
                    await retrieveCacheBookingAction.execute()
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IBookingDetailsActionParams, void>({
                eventName: bookingTree.UpcomingPast.srClaim.Click,
                handler: async (payload) => {
                    if (payload?.data?.bookingId) {
                        _eventBus.emit({
                            eventName: "FLOW_CLOSE",
                            data: "AfterSalesBookingFlow",
                        });
                        updateRecoilState("lastVisitedPageForServiceRequestAtom", payload?.data?.pathName || "")
                        if (payload.data?.direction != "") {
                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: `/service-request-claim/${payload?.data?.bookingId}${payload.data?.direction ? `?direction=${payload.data?.direction == TripTypeEnum.IN_BOUND ? 'inbound' : payload.data?.direction == TripTypeEnum.OUT_BOUND ? 'outbound' : ""}` : ""}`,
                            });
                        } else {
                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: `/service-request-claim/${payload?.data?.bookingId}`,
                            });
                        }
                    }
                    // }
                }
            })
        )

        // RequestInvoice event handlers for UpcomingPastBooking page
        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: bookingTree.RequestInvoice.Popup.OpenClose,
                handler: async ({ data }) => {
                    if (data) {
                        requestInvoicePopupOpenCloseAction.setParams(data);
                        await requestInvoicePopupOpenCloseAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: bookingTree.RequestInvoice.Popup.Close,
                handler: async ({ data }) => {
                    if (data) {
                        requestInvoicePopupOpenCloseAction.setParams(data);
                        await requestInvoicePopupOpenCloseAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: bookingTree.RequestInvoice.Submit.Click,
                handler: async ({ data }) => {
                    if (data) {
                        requestInvoiceSubmitAction.setParams(data);
                        await requestInvoiceSubmitAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: bookingTree.UpgradeToPremium.Click,
                handler: async ({ data }) => {
                    if (data) {
                        upgradeToPremiumAction.setParams({
                            trip: data.trip,
                            bookingId: data.bookingId,
                            upgradeOutboundOffers: data.upgradeOutboundOffers,
                            upgradeInboundOffers: data.upgradeInboundOffers
                        });
                        await upgradeToPremiumAction.execute();
                    }
                }
            })
        );

        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: upgradeBookingTree.UpgradeBooking.ProcessUpgradeOffers,
                handler: async ({ data }) => {
                    if (data) {
                        processUpgradeOffersAction.setParams(data);
                        await processUpgradeOffersAction.execute();
                    }
                }
            })
        );

        this.registerEventSubscription(
            _eventBus.on<IAddShuttleTransferActionParams, void>({
                // Unreachable: nothing emits this any more — shuttle add goes through
                // the Manage End-to-end Journey section. Kept with the legacy
                // /bookings/add-shuttle page it routes to, to be removed together.
                eventName: bookingTree.AddShuttleTransfer.Click,
                handler: async (payload) => {
                    let context = this.getCtx<UpcomingPastBookingContext>("upcomingPastBookingContext")!;
                    addShuttleTransferClickAction.setParams(payload.data!)
                    await addShuttleTransferClickAction.execute();

                    if (addShuttleTransferClickAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        stopAction.execute();
                        context.bookingId = addShuttleTransferClickAction.result!

                        _eventBus.emit({
                            eventName: "FLOW_CLOSE",
                            data: "AfterSalesBookingFlow",
                        });
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: `/bookings/add-shuttle/${addShuttleTransferClickAction.result}`,
                        });
                    }
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        await passengerTypeAction.execute();
        updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);
    }
}

export const upcomingPastBookingStepDeclaration = new StepDefinition({
    stepName: "UpcomingPastBooking_Step",
    stepClass: UpcomingPastBookingStep
});